module.exports = __webpack_public_path__ + "static/media/pic_winie2_04.def7739b.png";